"use strict";

var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var secp256k1_1 = __importDefault(require("secp256k1"));

var sha3_1 = require("sha3");

var SIGN_MAGIC = "\x19Ethereum Signed Message:\n";
var keccak = new sha3_1.Keccak(256);

function hash(messageBuffer) {
  var prefixString = SIGN_MAGIC + messageBuffer.length;
  var merged = Buffer.concat([Buffer.from(prefixString, 'utf-8'), messageBuffer]);
  keccak.reset();
  keccak.update(merged);
  return keccak.digest('binary');
}

function recoverPublicKey(signatureBuffer, payloadBuffer) {
  var recoveryId = signatureBuffer.readUInt8(signatureBuffer.length - 1) - 27;
  return secp256k1_1.default.ecdsaRecover(signatureBuffer.subarray(0, signatureBuffer.length - 1), recoveryId, hash(payloadBuffer), false, Buffer.alloc);
}

var SigningUtil = /*#__PURE__*/function () {
  function SigningUtil() {
    _classCallCheck(this, SigningUtil);
  }

  _createClass(SigningUtil, null, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload, privateKey) {
        var payloadBuffer, privateKeyBuffer, msgHash, sigObj, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payloadBuffer = Buffer.from(payload, 'utf-8');
                privateKeyBuffer = Buffer.from(privateKey, 'hex');
                msgHash = hash(payloadBuffer);
                sigObj = secp256k1_1.default.ecdsaSign(msgHash, privateKeyBuffer);
                result = Buffer.alloc(sigObj.signature.length + 1, Buffer.from(sigObj.signature));
                result.writeInt8(27 + sigObj.recid, result.length - 1);
                return _context.abrupt("return", '0x' + result.toString('hex'));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "recover",
    value: function () {
      var _recover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signature, payload) {
        var publicKeyBuffer,
            signatureBuffer,
            payloadBuffer,
            pubKeyWithoutFirstByte,
            hashOfPubKey,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                publicKeyBuffer = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : undefined;
                signatureBuffer = Buffer.from(signature.startsWith('0x') ? signature.substring(2) : signature, 'hex'); // remove '0x' prefix

                payloadBuffer = Buffer.from(payload, 'utf-8');

                if (!publicKeyBuffer) {
                  // eslint-disable-next-line no-param-reassign
                  publicKeyBuffer = recoverPublicKey(signatureBuffer, payloadBuffer);
                }

                pubKeyWithoutFirstByte = publicKeyBuffer.subarray(1, publicKeyBuffer.length);
                keccak.reset();
                keccak.update(Buffer.from(pubKeyWithoutFirstByte));
                hashOfPubKey = keccak.digest('binary');
                return _context2.abrupt("return", '0x' + hashOfPubKey.subarray(12, hashOfPubKey.length).toString('hex'));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function recover(_x3, _x4) {
        return _recover.apply(this, arguments);
      }

      return recover;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(address, payload, signature) {
        var recoveredAddress;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return SigningUtil.recover(signature, payload);

              case 3:
                recoveredAddress = _context3.sent;
                return _context3.abrupt("return", recoveredAddress.toLowerCase() === address.toLowerCase());

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", false);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 7]]);
      }));

      function verify(_x5, _x6, _x7) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return SigningUtil;
}();

exports.default = SigningUtil;